import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=fe107bde&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports